module.exports = __webpack_public_path__ + "static/img/leap-skills-black.86674ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/leap-skills-black.png
// module id = hMM3
// module chunks = 1